import Modal from "bootstrap/js/dist/modal.js";
import BootstrapModalTemplate from "@Base/Templates/BootstrapModal.hbs";

export interface IBootstrapModal
{
	modalId: string;
	modalClass?: string;
	modalContent: string;
	modalContentClass?: string;
	modalTitle?: string;
	displayButtons: boolean;
	cancelButton?: string;
	confirmButton?: string;
}

export class ModalTools
{
	/**
	 * Generates and displays an alert modal
	 * @param message Message text
	 * @param title Modal Title
	 * @param displayButtons Should buttons be displayed at the bottom
	 */
	static DisplayAlert = (message: string, title?: string, displayButtons?: true): void =>
	{
		const dialogOptions: IBootstrapModal = {
			modalId: "generatedAlert",
			modalContent: message,
			modalTitle: title,
			displayButtons: displayButtons
		};

		ModalTools.DisplayGeneratedModal(BootstrapModalTemplate(dialogOptions));
	};

	static DisplayGeneratedModal = (modalHtml: string): void =>
	{
		const wrapper = document.createElement("div");
		wrapper.innerHTML = modalHtml;
		const modal = wrapper.firstElementChild;
		document.body.appendChild(modal);
		const modalInstance = new Modal(modal);
		modalInstance.show();

		modal.addEventListener("hidden.bs.modal", event =>
		{
			ModalTools.ModalDisposer(event.currentTarget);
		});
	};

	/**
	 * Display alert messages from an ajax call in a modal
	 * @param messages
	 */
	static DisplayMessages = (messages: { Error?: [{ Description: string; }], Warning?: [{ Description: string; }]; }): void =>
	{
		if (messages !== null && messages !== undefined)
		{
			let errors = "";

			if (messages.Error && messages.Error.length > 0)
			{
				for (let i = 0; i < messages.Error.length; i++)
				{
					if (i > 0)
					{
						errors += "\n";
					}

					errors += messages.Error[i].Description;
				}

				ModalTools.DisplayAlert(errors);
			}

			if (messages.Warning && messages.Warning.length > 0)
			{
				for (let i = 0; i < messages.Warning.length; i++)
				{
					if (i > 0)
					{
						errors += "\n";
					}

					errors += messages.Warning[i].Description;
				}

				ModalTools.DisplayAlert(errors);
			}
		}
	};

	static ModalDisposer = (element): void =>
	{
		const target = element as HTMLElement;
		const instance = Modal.getInstance(target);
		instance.dispose();
		target.remove();
	};
}